import { render, staticRenderFns } from "./TopCountries.vue?vue&type=template&id=58e2230f&"
import script from "./TopCountries.vue?vue&type=script&lang=js&"
export * from "./TopCountries.vue?vue&type=script&lang=js&"
import style0 from "./TopCountries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports